export default __webpack_public_path__ + "static/media/8.3f2bd8ae.png";